module.exports = __webpack_public_path__ + "img/img04.b01cb521.png";